<ng-container *ngIf="item$ | async as item">
    <ng-container *ngIf="linkActionItemGuard(item)">
        <ng-container *ngTemplateOutlet="linkTemplate; context: { item: item }"></ng-container>
    </ng-container>
    <ng-container *ngIf="buttonActionItemGuard(item)">
        <ng-container *ngTemplateOutlet="buttonTemplate; context: { item: item }"></ng-container>
    </ng-container>
    <ng-container *ngIf="multiActionItemGuard(item)">
        <ng-container *ngTemplateOutlet="multiActionButtonTemplate; context: { item: item }"></ng-container>
    </ng-container>
    <ng-container *ngIf="asyncMultiActionItemGuard(item)">
        <ng-container *ngTemplateOutlet="asyncMultiActionButtonTemplate; context: { item: item }"></ng-container>
    </ng-container>
</ng-container>

<ng-template #icon let-item="item">
    <ng-container *ngIf="pureIcon$ | async; else iconWithLabel">
        <ng-container *ngTemplateOutlet="iconWithoutLabel"></ng-container>
    </ng-container>

    <ng-template #iconWithoutLabel>
        <svg sh-icon *ngIf="item.icon" [name]="item.icon" [size]="item.iconSize || defaultIconSize" aria-hidden="true" class="sh-icon-button__icon"></svg>
    </ng-template>

    <ng-template #iconWithLabel>
        <ng-container *ngIf="item.iconPosition === 'left' || !item.iconPosition">
            <ng-container *ngTemplateOutlet="left"></ng-container>
        </ng-container>
        <ng-container *ngIf="item.iconPosition === 'right'">
            <ng-container *ngTemplateOutlet="right"></ng-container>
        </ng-container>
    </ng-template>

    <ng-template #left>
        <svg sh-icon *ngIf="item.icon" [name]="item.icon" [size]="item.iconSize || defaultIconSize" aria-hidden="true" class="sh-icon-button__icon"></svg>
        <span [ngClass]="labelClassNames$ | async">{{ item.label }}</span>
    </ng-template>

    <ng-template #right>
        <span [ngClass]="labelClassNames$ | async">{{ item.label }}</span>
        <svg sh-icon *ngIf="item.icon" [name]="item.icon" [size]="item.iconSize || defaultIconSize" aria-hidden="true" class="sh-icon-button__icon--end"></svg>
    </ng-template>
</ng-template>

<ng-template #linkTemplate let-item="item">
    @if (item.disabled) {
        <a
            #linkItem
            [ngClass]="classNames$ | async"
            [class.-sh-disabled]="item.disabled"
            [attr.aria-disabled]="item.disabled"
            [title]="title$ | async"
            tabindex="-1"
            (keydown.space)="linkPressed($event)"
            (keydown.enter)="linkPressed($event)"
            (mouseenter)="onHover($event)"
        >
            <ng-container *ngTemplateOutlet="icon; context: { item: item }"></ng-container>
        </a>
    } @else {
        <a
            #linkItem
            [ngClass]="classNames$ | async"
            [shNavigationLink]="item.navigationLink"
            tabindex="-1"
            (keydown.space)="linkPressed($event)"
            (keydown.enter)="linkPressed($event)"
            (mouseenter)="onHover($event)"
        >
            <ng-container *ngTemplateOutlet="icon; context: { item: item }"></ng-container>
        </a>
    }
</ng-template>

<ng-template #buttonTemplate let-item="item">
    <button
        #buttonItem
        type="button"
        [ngClass]="classNames$ | async"
        [disabled]="item.disabled"
        [type]="item.type || 'button'"
        [title]="title$ | async"
        (click)="handleActionItemClick($event, item)"
        (keydown.enter)="handleActionItemClick($event, item)"
        (keydown.space)="handleActionItemClick($event, item)"
        (mouseenter)="onHover($event)"
    >
        <ng-container *ngTemplateOutlet="icon; context: { item: item }"></ng-container>
        <span *ngIf="item.badgeLabel" class="sh-badge--update" style="margin-left: 0.5rem">{{ item.badgeLabel }}</span>
    </button>
</ng-template>

<ng-template #multiActionButtonTemplate let-item="item">
    <div class="sh-droppanel-wrapper" (click)="stopPropagationIfNeeded($event)" (shClickOutside)="setDropdownClosed()">
        <button
            #droppanelToggle
            type="button"
            [ngClass]="classNames$ | async"
            (click)="toggleDropdown()"
            [disabled]="item.disabled"
            aria-haspopup="true"
            [title]="title$ | async"
        >
            <ng-container *ngTemplateOutlet="icon; context: { item: item }"></ng-container>
        </button>
        <div
            #droppanel
            shChildIndex
            [ngClass]="droppanelClassNames$ | async"
            (click)="handleClickInsideDroppanel($event)"
            (keydown.enter)="handleClickInsideDroppanel($event)"
        >
            <ul class="sh-droppanel__list" aria-hidden="true" aria-label="submenu">
                <li *ngFor="let multiItem of item.actionItems" class="sh-droppanel__list__item">
                    <sh-droppanel-item [item]="multiItem" [focusIndex]="focusIndex" (hovered)="onHover($event)"></sh-droppanel-item>
                </li>
            </ul>
        </div>
    </div>
</ng-template>

<ng-template #asyncMultiActionButtonTemplate let-item="item">
    <div
        class="sh-droppanel-wrapper"
        (keyup)="stopPropagationIfNeeded($event)"
        (click)="stopPropagationIfNeeded($event)"
        (shClickOutside)="setDropdownClosed()"
    >
        @defer (prefetch on idle) {
            <button
                #droppanelToggle
                type="button"
                [ngClass]="classNames$ | async"
                (click)="toggleDropdown()"
                [disabled]="item.disabled || !(hasVisibleAsyncItems$ | async)"
                aria-haspopup="true"
                [title]="title$ | async"
            >
                <ng-container *ngTemplateOutlet="icon; context: { item: item }"></ng-container>
            </button>
            <div
                #droppanel
                [ngClass]="droppanelClassNames$ | async"
                (click)="handleClickInsideDroppanel($event)"
                (keydown.enter)="handleClickInsideDroppanel($event)"
            >
                <ul class="sh-droppanel__list" aria-hidden="true" aria-label="submenu">
                    <ng-container *ngFor="let multiItem$ of item.asyncActionItems">
                        @if (multiItem$ | async; as multiItem) {
                            @if (!$any(multiItem).hidden) {
                                <li class="sh-droppanel__list__item">
                                    @if (apiActionBundleGuard($any(multiItem))) {
                                        <ng-container *ngTemplateOutlet="apiBundleTemplate; context: { item: multiItem }"></ng-container>
                                    } @else {
                                        <sh-droppanel-item [item]="$any(multiItem)" [focusIndex]="focusIndex" (hovered)="onHover($event)"></sh-droppanel-item>
                                    }
                                </li>
                            }
                        }
                    </ng-container>
                </ul>
            </div>
        }
    </div>
</ng-template>

<ng-template #apiBundleTemplate let-item="item">
    @if (item.apiActions$ | async; as apiActions) {
        @for (apiAction of $any(apiActions); track apiAction.label) {
            <li class="sh-droppanel__list__item">
                <sh-droppanel-item [item]="apiAction" [focusIndex]="focusIndex" (hovered)="onHover($event)" )></sh-droppanel-item>
            </li>
        }
    }
</ng-template>
